import {route} from '@/router/route-utils'

const prefix = '/admin/contacts';

const routes = [

    route(
        prefix, 'admin.contacts.list', {
            components : {
                main: () => import('./views/AdminContactsListView')
            },
            requiresAuth: true,
            layout: 'LayoutFull',
            title: 'Anagrafica',
            breadcrumb: [
                {text: 'Anagrafica', active: true},
            ],
        }
    )

];

export default routes
